import CalculatorIcon from '../../../../../icons/calculator.svg';
import DollarTagIcon from '../../../../../icons/dollar-tag.svg';
import HandSelectClickIcon from '../../../../../icons/hand-select-click.svg';
import madeEasy from '../../../../../icons/madeEasy.svg';
import optionsTailored from '../../../../../icons/optionsTailored.svg'
import solutionsRight from '../../../../../icons/SolutionsRight.svg';

export default function PurchasingProcessData() {
    return {
        title: "Getting Covered is Easy",
        callToAction: {
            buttonTitle: "SEE RATES",
            href: "/landing/term-insurance",
        },
        steps: [
            {
                title: "Select Coverage",
                paragraphs: [
                    "Tell us a little about yourself and what you're looking for. You can let us know what you need, or we can help you decide with a few simple questions.",
                ]
            },
            {
                title: "Quote and Apply",
                paragraphs: [
                    "We go to the marketplace on your behalf to find the right solutions for you. We'll select the best product fit for your needs, and secure the lowest available cost. You can apply online in one fast, simple session.",
                ]
            },
            {
                title: "Purchase Policy",
                paragraphs: [
                    "Once the carrier makes you an offer, you can accept, purchase and receive your policy right then - online, same-day. It's life insurance made simple.",
                ]
            },
        ],
        stepsCallToAction:  {
            title: "Schedule a Consultation",
            image: "home/tablet2.png",
            paragraphs: [
                "Together, we'll review your best options from a choice of the top rated insurance companies and most competitive rates. It's easy, confidential and takes less than 15 minutes!",
            ],
            callToAction: {
                buttonTitle: "CONTACT A SPECIALIST",
                href: "/select-appointment",
            },
        },
    }
}


// WEBPACK FOOTER //
// ./src/components/Helpers/Data/Products/BusinessSolutions/PurchasingProcessData.js